import { Component } from '@angular/core';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'VIBEs';
  constructor() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get('token');
    token ? localStorage.setItem('sso.idtoken', token) : '';
    const app = initializeApp(environment.firebaseConfig);
    const analytics = getAnalytics(app);
  }
}
